import { GetSignedCookiesInput, GetSignedCookiesOutput } from '@amzn/coral_com-amazon-jwostoremanagementgateway'
import { getGatewayClient, getGatewayClientForRealm } from './client-factory/StoreManagementClientFactory'

/**
 * Fetches CloudFront signed cookies from the Gateway.
 *
 * On a regional app.justwalkout.com host, assets are served from the page's own origin/cell, so
 * the caller passes that host's own realm and the cookies are signed by the serving host's cell —
 * not the active cell, which follows the selected store/region and can differ (e.g. a PDX store
 * viewed on the IAD host). With no realm the active-cell client is used, so the legacy hosts are
 * unchanged.
 */
export const getSignedCookies = (realm?: string): Promise<GetSignedCookiesOutput> =>
    (realm ? getGatewayClientForRealm(realm) : getGatewayClient())
        .getSignedCookies(GetSignedCookiesInput.fromJson({})).toPromise()
